//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  signal,
  WritableSignal,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

//local imports
import { CatalogConstants, EditProjectMessage, ExportPackageMessage, ProgramModel, ProjectModel } from "@app/catalog";
import { BreadcrumbChangedMessage, BreadcrumbItemToggleMessage, Messenger, PresenterType } from "@app/shared";

@PresenterType({
  model: ProjectModel,
  key: "tileBottom",
})
@Component({
  selector: 'project-carousel-item-bottom',
  standalone: false,
  templateUrl: './project-carousel-item-bottom.component.html',
  styleUrl: './project-carousel-item-bottom.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectCarouselItemBottomComponent implements OnDestroy {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private selectedProjects: ProjectModel[] = [];
  private selectedPrograms: ProgramModel[] = [];
  private searchItems = [];

  public data: WritableSignal<ProjectModel> = signal<ProjectModel>(undefined);


  constructor(
    private messenger: Messenger,
  ) {
    this.messenger.subscribe(this, BreadcrumbChangedMessage, (message) => {
        if(message.breadcrumbName !== CatalogConstants.CATALOG) { 
            return;
        }
        message.breadcrumbs.forEach((item) => {

          if(item instanceof ProjectModel) {
            const exists = this.selectedProjects.some(project => project.id === item.id);
            if (!exists) {
              this.selectedProjects.push(item);
            }
          } else if(item instanceof ProgramModel) {
            const exists = this.selectedPrograms.some(program => program.id === item.id);
            if (!exists) {
              this.selectedPrograms.push(item);
            }
          }
        })
    });
  }

  public navigateToDetailPage() {
    const currentProject = this.data();

    this.searchItems.forEach((searchItem) => {
      this.messenger.send(new BreadcrumbItemToggleMessage(searchItem, CatalogConstants.CATALOG));
    });
    
    const isAlreadySelected = this.selectedProjects.some(project => project.id === currentProject.id);
    if (!isAlreadySelected) {
      this.messenger.send(new BreadcrumbItemToggleMessage(currentProject, CatalogConstants.CATALOG));
    }

    const currentParams = this.route.snapshot.queryParams;

    const queryParams = {
      ...currentParams,
      projectId: currentProject.id
    }

    this.router.navigate(["/catalog/project", currentProject.id], {
      relativeTo: this.route,
      queryParams
    });
  }

  public openExportPackage(){
    this.messenger.send(new ExportPackageMessage(this.data()));
  }

  public editProject() {
    this.messenger.send(new EditProjectMessage(this.data()));
  }

  ngOnDestroy() {
    this.messenger.unsubscribeByOwner(this);
  }
}
